import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type DataSetsState } from '../types';

const loadDataSetConfigsCase: CaseReducer<
  DataSetsState,
  PayloadAction<DataSetsState>
> = (_, action) => {
  return action.payload;
};

export { loadDataSetConfigsCase };
